import { getHeader, graphQlUrl, logout } from './config'
import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { onError } from 'apollo-link-error'
import { ApolloLink } from 'apollo-link'

// Create the subscription websocket client
// const wsClient = new SubscriptionClient('ws://localhost:3000/subscriptions', {
//   reconnect: true
// })

// Extend the network interface with the subscription client
// const networkInterfaceWithSubscriptions = addGraphQLSubscriptions(
//   networkInterface,
//   wsClient,
// )
const http = new HttpLink({
  uri: graphQlUrl
})

const tokenLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: getHeader()
  })
  return forward(operation)
})

const errorLink = onError(({ networkError }) => {
  if (networkError && networkError.statusCode >= 400 && networkError.statusCode !== 404 && networkError.statusCode < 500) {
    logout()
  }
})

const mainLink = tokenLink.concat(errorLink)

const apolloClient = new ApolloClient({
  link: mainLink.concat(http),
  cache: new InMemoryCache(),
  connectToDevTools: true
})

export default apolloClient



// WEBPACK FOOTER //
// ./src/apolloClient.js